<template>
    <div class="flex flex-row">
        <form-label :class="color" class="w-2/5 shrink-0 text-xs" v-if="name">
            {{ name }}
        </form-label>
        <select
            class="flex-1 min-w-0 r-select px-1 border border-gray-400 hover:border-gray-500 focus:border-blue-500 bg-white text-sm text-gray-900 appearance-none inline-block rounded focus:outline-none"
            :class="{ 'border border-red-500': error, 'hover:border-red-500': error }"
            :id="id"
            :required="required"
            v-model="computedValue"
        >
            <template v-if="placeholder">
                <option>
                    {{ placeholder }}
                </option>
            </template>
            <slot></slot>
        </select>

        <p v-if="error" class="m text-red-500 italic">
            {{ error }}
        </p>

        <!-- Shared property status/reset column — inert unless :resettable is
             passed (see PropertyOverrideIndicator.vue). -->
        <property-override-indicator class="ml-1"
            :resettable="resettable" :modified="modified" :inherited="inherited"
            @reset="$emit('reset')" />
    </div>
</template>

<script>
import PropertyOverrideIndicator from '../properties/PropertyOverrideIndicator.vue';

export default {
    components: { PropertyOverrideIndicator },
    props: {
        id: {
            type: String,
        },
        // Property override status — see PropertyOverrideIndicator.vue.
        resettable: { type: Boolean, default: null },
        modified: { type: Boolean, default: false },
        inherited: { type: Boolean, default: false },
        modelValue: {
            type: [String, Number, Boolean, Object, Array, Function],
            default: null,
        },
        name: {
            type: String,
            required: false,
        },
        required: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: String,
            required: false,
        },
        error: {
            type: String,
            required: false,
        },
        color: {
            type: String,
            required: false,
            default: 'text-white'
        }
    },
    data() {
        return {
            selected: this.modelValue,
        };
    },
    emits: ['update:modelValue', 'reset'],
    computed: {
        computedValue: {
            get() {
                return this.selected;
            },
            set(value) {
                this.selected = value;
                this.$emit('update:modelValue', value);
            },
        },
    },
    watch: {
        modelValue(value) {
            this.selected = value;
        },
    },
};
</script>
